import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { getController, getMessages, root } from '../../../../store/constants';
import { deleteSnackbar, snackbarErrorDefault, snackbarListArchived } from '../../snackbarsStack';
import { SegmentArchiveEvent, segmentTrackAction } from '../../../../middlewares/segment';
import { listArchive } from '../../../../rest/effects/list/listArchive';
import { IGetState, TBoardId, TListId } from '../../../../types/types';
import { getBoardByListId } from '../../../../store/model/selectors/getBoardByListId';
import { isListUsedInAutomation } from '../../../../store/model/list/selectors/isListUsedInAutomation';
import {
    ERROR_LIST_ARCHIVE_AUTOMATION,
    SNACKBAR_ID_LIST_DELETE_AUTOMATION
} from '../../aside_panel/listDetails/constants';
import { authUserSetUsedProFeatures } from '../../../../rest/effects/authUser/authUserSetUsedProFeatures';
import { getProFeaturesTrialActive } from '../../../../store/model/authUser/selectors/getProFeaturesTrialActive';
import {
    onToggleCardsSorting
} from '../../aside_panel/listDetails/sortingSection/hocs/CardsSortingSectionHOC/events/onToggleCardsSorting';
import { openBoardSettings } from './openBoardSettings';
import { SegmentBoardSettingsSourceValue } from '../../../../middlewares/segment/trackEntities/boardEvents';
import { EBoardSetting } from '../../aside_panel/boardDetails/details/TabDetails/components/TabDetails/types';

export const archiveList: ActionCreator<ThunkAction> = (
    listId: TListId,
    boardId: TBoardId,
    checkPermissions: boolean = true,
    sendEvents: boolean = true
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const board = getBoardByListId(getState(), listId);
        if (isListUsedInAutomation(listId, board)) {
            setTimeout(() => {
                const link = document.getElementById(SNACKBAR_ID_LIST_DELETE_AUTOMATION + '-link');
                if (link) link.onclick = () => {
                    dispatch(openBoardSettings(EBoardSetting.STATUS_MAPPING, SegmentBoardSettingsSourceValue.LIST_DELETE_SNACKBAR));
                    dispatch(deleteSnackbar(SNACKBAR_ID_LIST_DELETE_AUTOMATION));
                }
            }, 0);
            return dispatch(snackbarErrorDefault({
                id: SNACKBAR_ID_LIST_DELETE_AUTOMATION,
                text: ERROR_LIST_ARCHIVE_AUTOMATION
            }));
        }
        if (!checkPermissions || getController().blockerHelper.allowArchive()) {
            if (sendEvents) {
                dispatch(segmentTrackAction(SegmentArchiveEvent.ARCHIVE_LIST));
            }
            root.App.controller.mainView.renderBlockerModal({
                text: getMessages().getText('popup.list.archiving'),
                title: getMessages().getText('popup.list.archiving.header'),
            });
            return dispatch(listArchive(listId))
                .then(() => {
                    root.App.vent.trigger(root.App.vent['aside-panel:hide']);
                    root.App.vent.trigger(root.App.vent['dialog:closed']);
                    dispatch(snackbarListArchived());
                    dispatch(onToggleCardsSorting(listId, false));
                    root.App.controller.mainView.removeBlockerModal();
                    if (getProFeaturesTrialActive(getState())) {
                        dispatch(authUserSetUsedProFeatures('allowArchive'));
                    }
                })
                .catch((err: any) => {
                    root.App.vent.trigger(root.App.vent['aside-panel:hide']);
                    root.App.vent.trigger(root.App.vent['dialog:closed']);
                    root.App.controller.mainView.removeBlockerModal();
                    return Promise.reject();
                })
        }
        return Promise.reject();
    };
    return action;
};
